import Layout from '@/layout';
var productQaRouter = {
  path: '/productQa',
  component: Layout,
  redirect: '/productQa/list',
  name: 'ProductQa',
  meta: {
    title: '问答',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/productQa/index');
    },
    name: 'ProductQaList',
    meta: {
      title: '问答管理',
      icon: ''
    }
  }, {
    path: 'category',
    component: function component() {
      return import('@/views/productQa/category/index');
    },
    name: 'ProductQaCategory',
    meta: {
      title: '问答分类管理',
      icon: ''
    }
  }]
};
export default productQaRouter;